import 'css-chunksrc/client/pages/utilityPage/projectReportTemplatePage/reportPreview/styles.scss';export default {
  "preview": "_preview_1i9sp_1",
  "header": "_header_1i9sp_8",
  "headerTitle": "_headerTitle_1i9sp_16",
  "body": "_body_1i9sp_23",
  "nameInput": "_nameInput_1i9sp_33",
  "mockInfo": "_mockInfo_1i9sp_44",
  "section": "_section_1i9sp_49",
  "sectionTitle": "_sectionTitle_1i9sp_53",
  "indicatorsList": "_indicatorsList_1i9sp_59",
  "indicatorSlot": "_indicatorSlot_1i9sp_68",
  "addIndicatorSlot": "_addIndicatorSlot_1i9sp_79",
  "indicatorVisual": "_indicatorVisual_1i9sp_87",
  "indicatorIcon": "_indicatorIcon_1i9sp_94",
  "indicatorRemove": "_indicatorRemove_1i9sp_99",
  "removeSmallIcon": "_removeSmallIcon_1i9sp_113",
  "indicatorNameInput": "_indicatorNameInput_1i9sp_118",
  "fieldsList": "_fieldsList_1i9sp_138",
  "fieldCard": "_fieldCard_1i9sp_142",
  "fieldHeader": "_fieldHeader_1i9sp_149",
  "moveHandle": "_moveHandle_1i9sp_157",
  "moveIcon": "_moveIcon_1i9sp_165",
  "fieldNameInput": "_fieldNameInput_1i9sp_175",
  "fieldRemove": "_fieldRemove_1i9sp_193",
  "fieldBody": "_fieldBody_1i9sp_204",
  "fieldTextarea": "_fieldTextarea_1i9sp_209",
  "fieldDisabled": "_fieldDisabled_1i9sp_215",
  "dropPreview": "_dropPreview_1i9sp_220",
  "dropPreviewHeader": "_dropPreviewHeader_1i9sp_227",
  "dropPreviewBody": "_dropPreviewBody_1i9sp_235",
  "emptyDropzone": "_emptyDropzone_1i9sp_239",
  "emptyDropzoneText": "_emptyDropzoneText_1i9sp_248",
  "addFieldButton": "_addFieldButton_1i9sp_253"
};